import '../tools-pages.css'

import { cap } from '../../State'
import { translations } from '../../translations'
import { HotelServices } from './HotelServices'
import { PlaneServices } from './PlaneServices'
import { TrainServices } from './TrainServices'

const language = cap.language.state || 'IT'
const t = translations[language]

export const TestDyn = () => {
  return (
    <div className="testdyn-page">
      <div className="nora-page__head">
        <div>
          <h1 className="nora-page__title">{t.tdAnteprimaRisultatiDinamico}</h1>
          <p className="nora-page__sub">{t.tdSottotitoloAnteprima}</p>
        </div>
      </div>
      <HotelServices />
      <TrainServices />
      <PlaneServices />
    </div>
  )
}
